export { default }from './StepPayment';
